// import useMyProperties from "../../Hooks/UseMyProperties/UseMyPropertiesHook";
import PropertyLinkIcon from "./PropertyLinkIcon";

export default function PropertyTitleTextSimple(props: {
    propertyId?: string
    propertyTitle?: string
    size?: number
    viewBox?: string
    shortName?: boolean
    showLink?: boolean
}) {
    const {
        propertyId = 'XXXXXXXXXXXXX',
        propertyTitle = 'Unknown Property',
        size = 16,
        viewBox = "0 0 20 20",
        shortName = false,
        showLink = true
    } = props;
    let propertyName = `Property ${propertyId}`;
    // const { myProperties } = useMyProperties()

    // if (myProperties && propertyId && myProperties[propertyId]) {
    //     propertyName = myProperties[propertyId].title;
    //     if (shortName) {
    //         propertyName = propertyName.split(' - ')[0];
    //     }
    // }

    if (propertyTitle) {
        propertyName = propertyTitle;
        if (shortName) {
            propertyName = propertyName.split(' - ')[0];
        }
    }   

    return (
        <>
            {propertyName}
            <PropertyLinkIcon propertyId={showLink ? propertyId : undefined} size={size} viewBox={viewBox} />
        </>
    )
}